const isProduction = process.env.NODE_ENV === 'production';

export const appConfig = {

  baseUrl: 'https://app.hejvi.de/',
  ttsProvider: 'browser',   // ← 'browser' oder 'openai'

  // Base URL for the web app (used for QR code validation)
  webAppBaseUrl: 'app.hejvi.de',

  apiBaseUrl: isProduction ? 'https://app.hejvi.de/api' : '/api',
  // HIER DIE NEUE EINSTELLUNG:
  enableModerationReview: false, // "true" schaltet die KI-Vorschläge an, "false" schaltet sie aus.

  // Sprachen, die im UI zur Auswahl stehen (Fallback wenn Backend keine zurückgibt)
  // Muss mit config.php → ui_languages übereinstimmen
  uiLanguages: ['de', 'en', 'fr', 'es', 'ru', 'ar', 'pl', 'ro', 'tr', 'hr'],

  pagination: {
    feedPerPage: 5,
    defaultPerPage: 5,
    maxPerPage: 50
  },

  // Workflow configuration
  workflow: {
    // VIDEO WORKFLOW CONTROL:
    // true  = Video plays instantly when clicked/scanned (direct play)
    // false = Shows detail page first, then user clicks to play (two-step)
    directVideoPlay: true ,
    
    // Enable progress tracking for video resume functionality
    enableProgressTracking: true,
    // If video is more than 90% played, restart from beginning
    videoResumeThreshold: 90
  }
};

export default appConfig;


